import React from 'react';

export const OverallCurrentPage = React.createContext();
export const User = React.createContext();